import { create } from 'zustand';
import { createDI } from '../../../context/di/di';
import { ApiError, useApi } from '../../../api/api';
import {IncidentListReponse} from "../../../model/incident_response";
import {CompanyListResponse, CompanyResponse} from "../../../model/company_response";
import {AccountRegisterRequest} from "../../../model/account_register_request";
// import {AccountRegisterReponse} from '../../../model/account_response';

/**
 * アカウント追加画面 アクションを管理するための DI コンテキスト(アクション)
 */
export type AccountRegisterAction = {
  /**
   * 会社一覧取得
   * @param businessType
   */
  getCompanies: () => Promise<CompanyListResponse>;
  /**
   * アカウント登録
   * @param リクエスト情報
   */
  registerAccount: (item: AccountRegisterRequest) => Promise<void>;
};

/**
 * アカウント追加画面 状態とアクションを管理するための DI コンテキストを作成
 */
const [Provider, use] = createDI<AccountRegisterAction>();
export { Provider as AccountRegisterProvider, use as useAccountRegisterStore };

/**
 * アカウント追加画面 状態とアクション
 */
export const defaultAccountRegisterStore = () => {
  const api = useApi();

  // @ts-ignore
  return create<AccountRegisterAction>(() => {
    return {
      getCompanies: async () => {
        const resp = await api.path('/api/resources/companies').get();
        if (resp.isError) {
          throw new ApiError(resp);
        }
        return resp.data as CompanyListResponse;
      },
      registerAccount: async (item: AccountRegisterRequest) => {
        const resp = await api.path('/api/accounts').post(item);
        if (resp.isError) {
          throw new ApiError(resp);
        }
      },
    };
  });
};
